module.exports = __webpack_public_path__ + "img/profile_default@3x.94458a6d.png";